import { toast } from "react-toastify";
import { graphqlUri } from "../../../Config/Env";

/**
 * 관리자 엑셀 다운로드 공통 처리.
 * 화면의 검색조건을 그대로 넘겨 보고 있는 목록과 같은 내용을 받는다.
 */
export default async (path, params, filename) => {
  try {
    const token = localStorage.getItem("token");
    const query = Object.entries(params || {})
      .filter(([, value]) => value !== undefined && value !== null && value !== "")
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const res = await fetch(
      `${graphqlUri}/excels/${path}${query ? `?${query}` : ""}`,
      {
        method: "POST",
        mode: "cors",
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      }
    );

    if (!res.ok) {
      const msg = await res.text();
      toast.error(msg || "엑셀 다운로드에 실패했습니다.");
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    a.remove();
  } catch (e) {
    console.log(e);
    toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
  }
};
